// extracted by mini-css-extract-plugin
module.exports = {"UsallyDetail":"_3u3oD5GoAEIy6DuSxFMd_d"};